module.exports = __webpack_public_path__ + "img/buy-one.bafb7bec.svg";